import { ORDER_TYPE, ORDER_TYPE_SUB } from '../constant/common';

export const getCartOptionValidationErrors = (cartItems, groupsByItem = {}, choices = {}, items = {}, orderType) => {
    const errors = [];
    for (const item of cartItems || []) {
        const itemName = items[item.itemId]?.name || item.itemName || 'An item';
        const groups = groupsByItem[item.itemId] || [];
        const counts = {};
        const available = option => {
            if (!option || option.deletedAt || option.isHideAddOn === true || option.isHideVariant === true) return false;
            const ots = Array.isArray(option.ots) ? option.ots : (option.ots?.[item.itemId] || []);
            return ots.length === 0 || ots.includes('DEFAULT') || ots.includes(orderType) ||
                (orderType === ORDER_TYPE_SUB.OTHER_DELIVERY && ots.includes(ORDER_TYPE.DELIVERY));
        };
        const fail = (groupName, message) => errors.push({ itemName, groupName, message });
        const check = (choiceId, groupId, quantity, isAddOn) => {
            const choice = choices[choiceId];
            const group = groups.find(value => value.uniqueId === groupId);
            const name = choice?.name || group?.name || 'Add-on / Variant';
            if (!group || !choice || choice.outletItemAddOnId !== groupId) {
                fail(name, 'This option does not belong to this item or is no longer available. Please edit or remove the item.');
                return;
            }
            if (!available(group) || !available(choice)) {
                fail(name, 'This option is unavailable for this order. Please select again.');
                return;
            }
            if (!Number.isInteger(quantity) || quantity <= 0) {
                fail(name, 'Invalid option quantity. Please select again.');
                return;
            }
            if (isAddOn && ((choice.minSelect != null && quantity < choice.minSelect) ||
                (choice.maxSelect != null && quantity > choice.maxSelect))) {
                fail(name, `Quantity must be within ${choice.minSelect ?? 0}-${choice.maxSelect ?? 'any'}.`);
            }
            counts[groupId] = (counts[groupId] || 0) + quantity;
        };
        for (const option of item.addOnGroupList || []) {
            if (option.addOnId && option.outletItemAddOnId && option.addOnId !== option.outletItemAddOnId) {
                fail(option.choiceName || 'Add-on', 'Invalid option group. Please select again.');
                continue;
            }
            check(option.outletItemAddOnChoiceId, option.addOnId || option.outletItemAddOnId, option.quantity ?? 1, true);
        }
        for (const [id, selected] of Object.entries(item.choices || {})) {
            if (selected === true) check(id, choices[id]?.outletItemAddOnId, 1, false);
        }
        for (const group of groups) {
            if (!available(group)) continue;
            const isVariant = group.minSelect !== undefined && group.maxSelect !== undefined;
            const min = isVariant ? group.minSelect : (group.min || 0);
            const max = isVariant ? group.maxSelect : (group.max > 0 ? group.max : undefined);
            const quantity = counts[group.uniqueId] || 0;
            if (quantity < min || (max !== undefined && quantity > max)) {
                fail(group.name, `Selected ${quantity}, required ${min}-${max ?? 'any'}. Please select again.`);
            }
        }
    }
    return errors;
};
